import { toast } from 'react-toastify';

export const checkFreightValues = (validationCase: string, value: string) => {
  let validation = false;
  switch (validationCase) {
    case 'state':
      if (value === '') {
        toast.error('Selecione um estado!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'city':
      if (value === '') {
        toast.error('Selecione uma cidade!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'neighborhood':
      if (value === '') {
        toast.error('Selecione um bairro!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'street':
      if (value === '') {
        toast.error('Insira o logradouro!');
        validation = false;
        return false;
      }
      if (value.length < 3) {
        toast.error('Logradouro deve conter mais de 3 caracteres!');
        validation = false;
        return false;
      }
      if (value.length > 255) {
        toast.error('Logradouro deve conter menos de 255 caracteres!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'streetNumber':
      if (value === '' || value.length < 1) {
        toast.error('Insira o número!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    default:
      break;
  }
  return validation;
};

export const checkShare = (validationCase: string, value: string) => {
  let validation = false;
  switch (validationCase) {
    case 'copy':
      if (value === '') {
        toast.error('Erro ao copiar url!');
        validation = false;
        return false;
      }
      toast.success('Link copiado!');
      validation = true;
      return true;
    default:
      break;
  }
  return validation;
};

export const checkVariations = (validationCase: string, value: string[]) => {
  let validation = false;
  switch (validationCase) {
    case 'menor':
      toast.error(`Itens obrigatórios necessários: ${value}`);
      validation = false;
      return false;

    case 'vazio':
      toast.error(`Selecione pelo menos um item de: ${value}`);
      validation = false;
      return false;

    case 'minimo':
      toast.error(`Quantidade mínima do item ${value} inválida`);
      validation = false;
      return false;

    case 'adicionado':
      toast.success('Item adicionado ao carrinho');
      validation = true;
      return true;

    default:
      break;
  }
  return validation;
};

export const checkPaymentValues = (
  validationCase: string,
  value: string,
  required?: boolean,
) => {
  let validation = false;
  switch (validationCase) {
    case 'method': {
      if (!value) {
        toast.error('Selecione uma forma de pagamento!');
        return false;
      } else {
        validation = true;
        return true;
      }
    }
    case 'name':
      if (value === '') {
        toast.error('Insira o nome!');
        validation = false;
        return false;
      }
      if (value.length <= 3) {
        toast.error('Nome deve conter mais de 3 caracteres!');
        validation = false;
        return false;
      }
      if (value.length > 255) {
        toast.error('Nome deve conter menos de 255 caracteres!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'phone':
      if (value === '') {
        toast.error('Insira número do WhatsApp!');
        validation = false;
        return false;
      }
      if (value.length !== 11) {
        toast.error('Número inválido!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'cpf':
      if (required) {
        if (value === '') {
          toast.error('Insira o CPF!');
          validation = false;
          return false;
        }
        if (value !== '' && validateCpf(value) === false) {
          toast.error('CPF inválido!');
          validation = false;
          return false;
        }
        validation = true;
        return true;
      }
      if (value !== '' && validateCpf(value) === false) {
        toast.error('CPF inválido!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'email':
      if (value !== '' && validateEmail(value) === false) {
        toast.error('E-mail inválido!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'paymentMethod':
      if (value === '') {
        toast.error('Selecione uma forma de pagamento!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'holder':
      if (value === '') {
        toast.error('Insira o nome do titular!');
        validation = false;
        return false;
      }
      if (value.length <= 3) {
        toast.error('Nome deve conter mais de 3 caracteres!');
        validation = false;
        return false;
      }
      if (value.length > 255) {
        toast.error('Nome deve conter menos de 255 caracteres!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'cpfCard':
      if (value === '') {
        toast.error('Insira o CPF!');
        validation = false;
        return false;
      }
      if (value !== '' && validateCpf(value) === false) {
        toast.error('CPF inválido!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'cardNumber':
      if (value === '') {
        toast.error('Insira o número do cartão!');
        validation = false;
        return false;
      }
      if (value.length < 14) {
        toast.error('Número do cartão inválido!');
        validation = false;
        return false;
      }
      if (value.length > 16) {
        toast.error('Número do cartão inválido!');
        validation = false;
        return false;
      }
      if (!luhnCheck(value)) {
        toast.error('Número do cartão inválido!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'expiryDate':
      if (value === '') {
        toast.error('Insira a data de validade!');
        validation = false;
        return false;
      }
      if (value.length <= 3) {
        toast.error('Data de validade inválida!');
        validation = false;
        return false;
      }
      if (value.length > 4) {
        toast.error('Data de validade inválida!');
        validation = false;
        return false;
      }
      if (!validateExpiryDate(value)) {
        toast.error('Data de validade inválida!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    case 'securityCode':
      if (value === '') {
        toast.error('Insira o CVV!');
        validation = false;
        return false;
      }
      if (Number(value) > 99999) {
        toast.error('CVV de 1 a 5 dígitos!');
        validation = false;
        return false;
      }
      validation = true;
      return true;

    default:
      break;
  }
  return validation;
};

export const checkFavorite = (
  value: number,
  product: string,
  favorite: boolean,
) => {
  if (value !== 204) {
    toast.error('Ocorreu algum erro. Tente novamente mais tarde!');
    return false;
  }
  if (favorite) {
    toast.success(`Item ${product} removido dos Favoritos!`);
  } else {
    toast.success(`Item ${product} adicionado aos Favoritos!`);
  }
  return true;
};

export const checkOrder = (
  productName?: string,
  quantity?: boolean,
  variation?: string,
  variationItem?: string,
) => {
  if (productName && variation && !variationItem) {
    if (quantity) {
      toast.error(
        `Quantidade de itens da variação "${variation}" do produto "${productName}" diferente do permitido!`,
      );
    } else {
      toast.error(
        `Variação "${variation}" do produto "${productName}" indisponível!`,
      );
    }
    return false;
  }
  if (productName && !variation && !variationItem) {
    toast.error(`Produto "${productName}" indisponível!`);
    return false;
  }
  if (productName && variation && variationItem) {
    toast.error(
      `Item "${variationItem}" da variação "${variation}" do produto "${productName}" indisponível!`,
    );
    return false;
  }
  toast.success('Itens do pedido carregados!');
  return true;
};

export const validateCpf = (cpf: string) => {
  let Soma;
  let Resto;
  Soma = 0;
  if (
    !cpf ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }

  for (let i = 1; i <= 9; i++) {
    Soma += Number(cpf.substring(i - 1, i)) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== Number(cpf.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma += Number(cpf.substring(i - 1, i)) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== Number(cpf.substring(10, 11))) return false;
  return true;
};

const validateEmail = (email: string) => {
  const re = /[\w'+-]+(\.[\w'+-]+)*@\w+([-.]\w+)*\.\w{2,24}/;
  return re.test(String(email).toLowerCase());
};

const luhnCheck = (value: string) => {
  let sum = 0;
  let bEven = false;
  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    let nDigit = parseInt(cDigit, 10);

    // eslint-disable-next-line no-cond-assign
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

    sum += nDigit;
    bEven = !bEven;
  }
  return sum % 10 === 0;
};

const validateExpiryDate = (expiryDate: string) => {
  const exMonth = +expiryDate.substr(0, 2);
  const exYear = +expiryDate.substr(2, 4) + 2000;
  const today = new Date();
  const someday = new Date();
  someday.setFullYear(exYear, exMonth, 1);

  if (someday < today) {
    return false;
  }
  return true;
};
